import React, { useContext, useEffect } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { AppContext } from '../utils/reducers';
import useAuthActions from '../api/useAuthActions';

const AuthRoute = (props) => {
  const { state, dispatch } = useContext(AppContext);
  const { component: Component, ...otherProps } = props;
  const authActions = useAuthActions({ state, dispatch });
  const isAuthenticated = state.user.isAuthenticated;
  
  useEffect(() => {
    const cookieAuth = async () => {
      if (!isAuthenticated) {
        await authActions.cookieSignIn();
      }
    };
    cookieAuth();
  }, [isAuthenticated]);

  return (
    <Route {...otherProps} render={(p) => {
      if (!isAuthenticated) {
        return <Redirect to="/login" />;
      } else {
        return <Component {...p} />;
      }
    }} />
  );
}

export default AuthRoute;